<template>
  <div>
    <section class="">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'OrderList' }"
              tag="button"
              class="active"
            >
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CardInfo' }" tag="button">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li v-if="local != 'jp'">
            <router-link :to="{ name: 'CarbonReduction' }" tag="button">
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>
          <li></li>
        </ul>
        <div class="main">
          <div class="bg-box" style="margin-bottom: 20px">
            <ul class="text-box">
              <li class="title-box">
                <div class="box">
                  <div>{{ $t("點數紀錄") }}</div>
                </div>
              </li>
            </ul>
          </div>
          <div v-for="(Order, index) in Orders" :key="Order.OId">
            <hr v-if="index != 0" />
            <div class="bg-box">
              <ul class="text-box">
                <li>
                  <div>{{ $t("訂單編號") }}</div>
                  <div class="box">
                    <div>{{ Order.Number }}</div>
                  </div>
                </li>
                <hr />
                <li>
                  <div>{{ $t("商品名稱") }}</div>
                  <div>
                    {{ Order.PointProductName }}
                  </div>
                </li>
                <li v-if="Order.PlatNumber">
                  <div>{{ $t("車牌號碼") }}</div>
                  <div>
                    {{ Order.PlatNumber }}
                  </div>
                </li>
                <li>
                  <div>{{ $t("使用點數") }}</div>
                  <div>
                    {{ Order.UseBonus }}
                  </div>
                </li>
                <li>
                  <div>{{ $t("建立時間") }}</div>
                  <div>
                    {{ timeString(Order.CreateTime, "YYYY/MM/DD HH:mm:ss") }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <section class="page" v-if="pageAll > 1">
            <div class="container">
              <paginate
                :no-li-surround="false"
                :page-count="pageAll"
                :page-range="5"
                :margin-pages="1"
                :click-handler="loadList"
                :prev-text="'<'"
                :next-text="'>'"
                :prev-link-class="'Prev'"
                :next-link-class="'next'"
                :container-class="''"
                :page-link-class="''"
                :active-class="'page-active'"
                :hide-prev-next="false"
              >
              </paginate>
            </div>
          </section>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Paginate from "vuejs-paginate";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);
Vue.component("paginate", Paginate);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    會員資料: "會員資料",
    我的套票: "我的套票",
    卡片資料: "卡片資料",
    套票兌換: "套票兌換",
    卡片交易紀錄: "卡片交易紀錄",
    其他資訊: "其他資訊",
    訂單編號: "訂單編號",
    查看: "查看",
    商品名稱: "商品名稱",
    時數票: "時數票",
    天數票: "天數票",
    點數商品: "點數商品",
    建立時間: "建立時間",
    狀態: "狀態",
    未付款: "未付款",
    已付款: "已付款",
    已退款: "已退款",
    張數: "張數",
    張: "張",
    使用中: "使用中",
    已失效: "已失效",
    轉贈中: "轉贈中",
    已轉贈: "已轉贈",
    總金額: "總金額",
    訂單詳情: "訂單詳情",
    申請退款: "申請退款",
    剩餘點數: "剩餘點數",
    使用效期: "使用效期",
    錯誤: "錯誤",
    "取得訂單過程發生錯誤, 請稍後再試一次":
      "取得訂單過程發生錯誤, 請稍後再試一次",
    確定: "確定",
    減碳計算: "減碳計算",
  },
  en: {
    會員資料: "Member Information",
    我的套票: "My Package Ticket",
    卡片資料: "Card Information",
    套票兌換: "Package Ticket Redemption",
    卡片交易紀錄: "Activity",
    其他資訊: "Other Descriptions",
    訂單編號: "Order Number",
    查看: "View",
    商品名稱: "Product name",
    時數票: "Hour Pass QR Package Ticket",
    天數票: "Day Pass QR Package  Ticket",
    點數商品: "Point product",
    建立時間: "Creation time",
    狀態: "Status",
    未付款: "Not paid",
    已付款: "Paid",
    已退款: "Refunded",
    張數: "Number of card",
    張: "Number",
    使用中: "In use",
    已失效: "Expired",
    轉贈中: "Transferring",
    已轉贈: "Transferred",
    總金額: "Total amount",
    訂單詳情: "Order details",
    申請退款: "Apply for refund",
    剩餘點數: "Remaining points",
    使用效期: "Service life",
    錯誤: "Error",
    "取得訂單過程發生錯誤, 請稍後再試一次":
      "An error occurred during getting the order. Please try again later",
    確定: "Confirm",
    減碳計算: "Carbon Reduced",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "PointOrderList",
  i18n,
  data() {
    return {
      Orders: [],
      pageAll: 0,
      perPage: 3,
      local: "zh_tw",
      IsTester: false,
    };
  },
  created: function () {
    let that = this;
    $.ajax({
      url:
        that.GLOBAL.apiSrc +
        that.GLOBAL.subDirectory +
        "/Htmlv2/PointOrderList",
      //url: "https://localhost:44321/Html/OrderInfo",
      type: "post",
      data: {
        token: Storage.get("ek_login_token"),
      },
      dataType: "json",
      error: function () {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("取得訂單過程發生錯誤, 請稍後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
      },
      success: function (res) {
        that.IsTester = res.IsTester ? res.IsTester : false;
        // 判斷結果
        if (res.ok) {
          // 僅做登入驗證
        } else if (res.error_msg) {
          var error_msg = JSON.parse(res.error_msg);
          if (res.toekn_error) {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              willClose: function () {
                // 移除登入資訊
                Storage.remove("ek_login_token");
                // 回到首頁
                that.$router.push({
                  name: "Home",
                  params: {},
                });
              },
            });
          } else {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        }
      },
    });
  },
  mounted: function () {
    this.loadList(1);
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member-order");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  updated: function () {},
  methods: {
    loadList: function (page) {
      var that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/_PointOrderList",
        type: "post",
        data: {
          token: Storage.get("ek_login_token"),
          o_maas_so_nbr: that.$route.params.o_maas_so_nbr,
          page: page,
          perPage: this.perPage,
        },
        dataType: "json",
        error: function () {},
        success: function (res) {
          if (res.status == 1) {
            that.Orders = res.Orders;
            that.perPage = res.perPage;
            that.pageAll = Math.max(Math.ceil(res.total / that.perPage), 1);
            window.pageYOffset = 0;
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          }
        },
      });
    },
    timeString(time, format) {
      return moment(time).format(format || "YYYY-MM-DD, HH:mm:ss");
    },
    openDetail(id) {
      console.log("1");
      $("#" + id)
        .children()
        .toggleClass("spanadd");
      $("#" + id)
        .parents(".text-box")
        .next(".content")
        .toggleClass("contentadd");
      $("#" + id)
        .parents(".text-box")
        .next(".content")
        .children(".detail-box")
        .removeClass("detail-boxadd");
    },
    openTickerDetail(id) {
      console.log("2");
      $("#" + id)
        .children()
        .toggleClass("spanadd");
      $("#" + id)
        .parents("li")
        .siblings(".detail-box")
        .toggleClass("detail-boxadd");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PointOrderList.vue